module.exports = __webpack_public_path__ + "img/alex_assessment_grey.880ee31b.svg";